import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAirportTabs, LazyAlert, LazyBenefits, LazyBreadcrumbs, LazyButton, LazyCarousel, LazyCheckmarkList, LazyCoreAccordion, LazyCoreAccordionList, LazyCoreAdvancedTitle, LazyCoreBanner, LazyCoreCountdownSection, LazyCoreCustomProductsCarousel, LazyCoreDynamicComponents, LazyCoreEventComponent, LazyCoreFeatureList, LazyCoreJetparkSearchbox, LazyCoreLayout, LazyCoreLinkList, LazyCoreLinkWrapper, LazyCorePage, LazyCorePropelProductCard, LazyCoreShuttleRouteMap, LazyCoreSimpleCard, LazyCoreSimpleImage, LazyCoreSimpleLink, LazyCoreSimpleRichText, LazyCoreSimpleTitle, LazyCoreVideo, LazyCountdownCodeReveal, LazyCountdownEmailSubscription, LazyCountdownEmailSubscriptionForm, LazyCountdownTimer, LazyCouponList, LazyFooter, LazyFormDatepicker, LazyFormInput, LazyFormSelect, LazyFormTextarea, LazyGeneralText, LazyHeader, LazyHelpCancellation, LazyHelpContact, LazyHelpNav, LazyHelpReceipt, LazyHelpSection, LazyHelpUnsubscribe, LazyHero, LazyHotelProductCard, LazyIconTitle, LazyImageText, LazyImageTmp, LazyLinkCard, LazyLinkList, LazyLinkText, LazyLoungeBookingCard, LazyMultiColumnsLayoutNew, LazyMultiFaqsSection, LazyOTCookieButton, LazyOTCookieTables, LazyOffersSection, LazyOtNotice, LazyPage, LazyPageTitle, LazyParkingProductCard, LazyResetPasswordModal, LazyRouteMap, LazySbSimplePage, LazySearchbox, LazyShuttleLinksList, LazyShuttlePartners, LazySignInModal, LazySignUpModal, LazySimpleHero, LazySimpleImage, LazyTable, LazyTextHtml, LazyTextTitle, LazyTextTitleIconList, LazyTransferOptions, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["AirportTabs", LazyAirportTabs],
["Alert", LazyAlert],
["Benefits", LazyBenefits],
["Breadcrumbs", LazyBreadcrumbs],
["Button", LazyButton],
["Carousel", LazyCarousel],
["CheckmarkList", LazyCheckmarkList],
["CoreAccordion", LazyCoreAccordion],
["CoreAccordionList", LazyCoreAccordionList],
["CoreAdvancedTitle", LazyCoreAdvancedTitle],
["CoreBanner", LazyCoreBanner],
["CoreCountdownSection", LazyCoreCountdownSection],
["CoreCustomProductsCarousel", LazyCoreCustomProductsCarousel],
["CoreDynamicComponents", LazyCoreDynamicComponents],
["CoreEventComponent", LazyCoreEventComponent],
["CoreFeatureList", LazyCoreFeatureList],
["CoreJetparkSearchbox", LazyCoreJetparkSearchbox],
["CoreLayout", LazyCoreLayout],
["CoreLinkList", LazyCoreLinkList],
["CoreLinkWrapper", LazyCoreLinkWrapper],
["CorePage", LazyCorePage],
["CorePropelProductCard", LazyCorePropelProductCard],
["CoreShuttleRouteMap", LazyCoreShuttleRouteMap],
["CoreSimpleCard", LazyCoreSimpleCard],
["CoreSimpleImage", LazyCoreSimpleImage],
["CoreSimpleLink", LazyCoreSimpleLink],
["CoreSimpleRichText", LazyCoreSimpleRichText],
["CoreSimpleTitle", LazyCoreSimpleTitle],
["CoreVideo", LazyCoreVideo],
["CountdownCodeReveal", LazyCountdownCodeReveal],
["CountdownEmailSubscription", LazyCountdownEmailSubscription],
["CountdownEmailSubscriptionForm", LazyCountdownEmailSubscriptionForm],
["CountdownTimer", LazyCountdownTimer],
["CouponList", LazyCouponList],
["Footer", LazyFooter],
["FormDatepicker", LazyFormDatepicker],
["FormInput", LazyFormInput],
["FormSelect", LazyFormSelect],
["FormTextarea", LazyFormTextarea],
["GeneralText", LazyGeneralText],
["Header", LazyHeader],
["HelpCancellation", LazyHelpCancellation],
["HelpContact", LazyHelpContact],
["HelpNav", LazyHelpNav],
["HelpReceipt", LazyHelpReceipt],
["HelpSection", LazyHelpSection],
["HelpUnsubscribe", LazyHelpUnsubscribe],
["Hero", LazyHero],
["HotelProductCard", LazyHotelProductCard],
["IconTitle", LazyIconTitle],
["ImageText", LazyImageText],
["ImageTmp", LazyImageTmp],
["LinkCard", LazyLinkCard],
["LinkList", LazyLinkList],
["LinkText", LazyLinkText],
["LoungeBookingCard", LazyLoungeBookingCard],
["MultiColumnsLayoutNew", LazyMultiColumnsLayoutNew],
["MultiFaqsSection", LazyMultiFaqsSection],
["OTCookieButton", LazyOTCookieButton],
["OTCookieTables", LazyOTCookieTables],
["OffersSection", LazyOffersSection],
["OtNotice", LazyOtNotice],
["Page", LazyPage],
["PageTitle", LazyPageTitle],
["ParkingProductCard", LazyParkingProductCard],
["ResetPasswordModal", LazyResetPasswordModal],
["RouteMap", LazyRouteMap],
["SbSimplePage", LazySbSimplePage],
["Searchbox", LazySearchbox],
["ShuttleLinksList", LazyShuttleLinksList],
["ShuttlePartners", LazyShuttlePartners],
["SignInModal", LazySignInModal],
["SignUpModal", LazySignUpModal],
["SimpleHero", LazySimpleHero],
["SimpleImage", LazySimpleImage],
["Table", LazyTable],
["TextHtml", LazyTextHtml],
["TextTitle", LazyTextTitle],
["TextTitleIconList", LazyTextTitleIconList],
["TransferOptions", LazyTransferOptions],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
